const React = require("react");
const PCardActionCreators = require("../../actionCreators/metadata/PCardActionCreators.js");

const PCardForm = React.createClass({

    componentDidMount() {
        PCardActionCreators.SelectTarget('test');
    },

    render() {
        return (
            <div class="form-inline">
                Mode:&nbsp;
                <select onChange={this.TargetChanged} name="Mode" id="Mode" class="form-control">
                    <option value="test">Test</option>
                    <option value="prod">Send To Stores</option>
                </select>
            </div>
        );
    },

    TargetChanged(e) {
        console.log(e.target.value);
        PCardActionCreators.SelectTarget(e.target.value);
    }
});

module.exports = PCardForm;


// WEBPACK FOOTER //
// ./src/components/metadata/PCardForm.jsx